import type { AvatarsSubtitleStyle } from '../../../modules/avatars/types/subtitles';

/**
 * Subtítulos de MACRO. Estilo pill morado con texto blanco bold, matchea la
 * referencia de Adobe Premiere del equipo de branding:
 *   - Font size: 65
 *   - Tamaño del solido (padding uniforme): 35
 *   - Bordeado (border radius): 25
 *
 * Mismos valores para landscape y portrait — sin escalado por orientación.
 *
 * Se aplica en el editor al primer boot (`editorState === null`) — después el
 * user puede editar visualmente sin perder los estilos (los pills son objetos
 * nativos del editor).
 */
export const MACRO_AVATARS_SUBTITLE_STYLE: AvatarsSubtitleStyle = {
  textFill: '#FFFFFF',
  fontFamily: 'Inter',
  fontSize: 65,
  fontWeight: 700,

  pillFill: '#5B4CFF',
  borderRadius: 25,
  paddingX: 35,
  paddingY: 20,

  shadow: {
    color: 'rgba(0, 0, 0, 1)',
    offsetX: 3,
    offsetY: 3,
    blur: 12
  },

  bottomRatio: 0.85
};
